module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-549.3d69dba.woff2";